export var ENTITY = "payment-group";
export var REDUCER_KEY = "PAYMENT_GROUPS_V2";
export var BASE_PATH_ENTITY = "payment-groups";
export var GENERATOR_PARAMS = {
    entity: ENTITY,
    reducerKey: REDUCER_KEY,
    basePathEntity: BASE_PATH_ENTITY,
};
